export default __webpack_public_path__ + "static/media/bitorange.e69164a1.svg";